import React from 'react';
import {AuthedLayout} from 'components/Layout';

const RecruitLazy = React.lazy(() => import(/* webpackChunkName: "Recruit" */ './Recruit'));
const RecruitCandidateListLazy = React.lazy(() => import(/* webpackChunkName: "RecruitCandidateList" */ './RecruitCandidateList'));

export const Recruit = props => <AuthedLayout component={RecruitLazy} {...props} />;
export const RecruitCandidateList = RecruitCandidateListLazy;
